 
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import PropertyDetail from "../../commonComponents/productDetail/PropertyDetail";

const PropertySidebarLayoutContainer = () => {
  return (
    <>
      <Breadcrumbs title="Property Details" url={routes.Home.PropertyDemo1} />
      <PropertyDetail type="sidebar-layout" mainClass="property-sidebar-section section-t-space ratio_30" />
    </>
  );
};

export default PropertySidebarLayoutContainer;
